<template>
  <div
    class="w-[90%] mx-auto max-w-xl min-h-screen flex items-center justify-center py-[20vh] pt-[14vh]"
  >
    <div
      class="w-full flex md:flex-row flex-col-reverse md:gap-0 gap-8 items-center"
    >
      <div class="md:w-1/4 w-full">
        <div class="w-full">
          <h4 class="text-3xl font-inter font-medium">Get in Touch</h4>
          <p class="font-verdana font-medium mt-2">
            Email:
            <a class="inline-block ml-1" href="mailto:info@qoraymobility.com"
              >info@qoraymobility.com</a
            >
          </p>
          <p class="font-verdana font-medium mt-2">
            Phone:
            <a class="inline-block ml-1" href="tel:+2348133059384"
              >+234 813 305 9384</a
            >
          </p>
        </div>
        <div class="w-full mt-14">
          <h4 class="text-3xl font-inter font-medium">Visit Us</h4>
          <p class="font-verdana font-medium mt-2">
            20 Marina, Lagos, Nigeria.
          </p>
        </div>
        <div class="w-full mt-14">
          <h4 class="text-3xl font-inter font-medium">Connect with Us</h4>
          <p class="font-verdana font-medium mt-2 md:w-2/3">
            Follow us on social media to stay updated on our latest innovations
            and community initiatives.
          </p>
          <div class="flex items-center w-full gap-6 mt-12 mb-16 text-black">
            <a href="https://www.instagram.com/qoraymobility/" target="_blank">
              <Instagram />
            </a>
            <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/threads.svg" alt="" />
        </a> -->
            <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/linkedin.svg" alt="" />
        </a> -->
            <a href="https://x.com/qoraymobility" target="_blank">
              <!-- <img src="@/assets/svgs/twitter.svg" alt="" /> -->
              <Twitter />
            </a>
            <a href="https://www.youtube.com/@QorayMobility" target="_blank">
              <!-- <img src="@/assets/svgs/youtube.svg" alt="" /> -->
              <Youtube />
            </a>
            <!-- <a href="" target="_blank">
          <img src="@/assets/svgs/facebook.svg" alt="" />
        </a> -->
          </div>
        </div>
      </div>
      <div
        class="md:w-3/4 w-full min-h-[70vh] gap-6 md:grid flex flex-col-reverse md:items-stretch items-start md:grid-cols-3 md:grid-rows-2 grid-cols-1 text-white font-verdana"
      >
        <!-- <div
          class="md:hidden bg-[#1C1C1E] md:px-7 md:py-7 px-4 py-6 rounded-2xl md:col-span-2 flex md:items-end items-center justify-between md:gap-4 gap-1 w-full"
        >
          <div class="md:w-2/5 w-1/2">
            <h2>Charge Station Self Service Guide</h2>
            <p class="mt-2">Charge Station Self Service Guide</p>
            <a
              href="/assets/doc/Qoray Charge Station Self-Service Guide.pdf"
              target="_self"
            >
              <button class="mt-6">View</button>
            </a>
          </div>
          <div class="md:w-3/5 w-1/2 flex justify-end">
            <img
              src="@/assets/images/selfService/self-ser.png"
              class="w-full md:block hidden"
              alt=""
            />
            <img
              src="@/assets/images/selfService/self-ser-mob.png"
              class="w-full block md:hidden"
              alt=""
            />
          </div>
        </div> -->
        <div
          class="bg-[#1C1C1E] rounded-2xl md:row-span-2 md:px-7 md:py-7 px-4 py-6 md:block flex flex-row-reverse md:items-stretch items-center gap-4 w-full"
        >
          <img
            class="block md:hidden w-1/2"
            src="@/assets/images/selfService/converter.png"
          />
          <div
            class="flex flex-col h-full md:items-stretch items-start justify-between"
          >
            <div class="md:flex items-center justify-between">
              <p class="text-xs md:hidden block mb-1">Step 3.</p>
              <h2>
                Charge Station Converter <br />
                How-to-Guide
              </h2>
              <a
                class="md:block hidden"
                href="/assets/doc/Qoray Charge Station Converter How-to-Guide.pdf"
                target="_self"
              >
                <button>View</button>
              </a>
            </div>
            <img
              class="md:block hidden w-full"
              src="@/assets/images/selfService/converter.png"
            />
            <p class="md:mt-0 mt-2">
              How to Use an Adapter to Connect Your EV to a Qoray Charger
            </p>
            <a
              class="inline-block md:hidden"
              href="/assets/doc/Qoray Charge Station Converter How-to-Guide.pdf"
              target="_self"
            >
              <button class="mt-6">View</button>
            </a>
          </div>
        </div>

        <div
          class="flex md:flex-row flex-row-reverse bg-[#1C1C1E] md:px-7 md:py-7 px-4 py-6 rounded-2xl md:col-span-2 md:items-end items-center justify-between md:gap-4 gap-1 w-full"
        >
          <div class="md:w-2/5 w-1/2">
            <p class="text-xs md:hidden block mb-1">Step 2.</p>
            <h2>Charge Station Self Service Guide</h2>
            <p class="mt-2">Charge Station Self Service Guide</p>

            <a
              href="/assets/doc/Qoray Charge Station Self-Service Guide.pdf"
              target="_self"
            >
              <button class="mt-6">View</button>
            </a>
          </div>
          <div class="md:w-3/5 w-1/2 flex justify-end">
            <img
              src="@/assets/images/selfService/self-ser.png"
              class="w-full md:block hidden"
              alt=""
            />
            <img
              src="@/assets/images/selfService/self-ser-mob.png"
              class="w-full block md:hidden"
              alt=""
            />
          </div>
        </div>
        <div
          class="w-full bg-[#1C1C1E] md:px-7 md:py-7 px-4 py-6 rounded-2xl relative md:min-h-0 min-h-[210px]"
        >
          <div class="md:w-2/3 w-1/2">
            <p class="text-xs md:hidden block mb-1">Step 1.</p>
            <h2>Download Qoray App</h2>
            <p class="mt-2">Get the Qoray app to stay updated</p>
            <router-link to="/apps">
              <button class="mt-6">Download</button>
            </router-link>
          </div>
          <img
            src="@/assets/svgs/app-phone.svg"
            alt="Phone"
            class="absolute right-0 bottom-0 md:w-auto w-1/2"
          />
        </div>
        <div
          class="md:flex hidden w-full bg-[#E0E0E0] rounded-2xl items-center justify-center md:px-7 md:py-7 px-4 py-6"
        >
          <img
            src="@/assets/svgs/downloadQR.svg"
            alt="Download QR Code"
            class="w-full"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Instagram from "@/components/Instagram.vue";
import Twitter from "@/components/Twitter.vue";
import Youtube from "@/components/Youtube.vue";
export default {
  components: {
    Instagram,
    Twitter,
    Youtube,
  },
};
</script>

<style scoped >
button {
  @apply bg-red text-white py-1 px-6 rounded-sm text-xs font-medium;
}
h2 {
  @apply md:text-2xl text-xl  font-bold leading-[100%];
}
p {
  @apply md:text-base text-xs font-inter;
}
</style>